module.exports = __webpack_public_path__ + "img/outdoor-night.886f2fbf.jpg";